import qs from 'query-string';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ProgramPayment: React.FC = () => {
	const { search } = useLocation();
	const navigate = useNavigate();

	React.useEffect(() => {
		const { program } = qs.parse(search);
		const section = localStorage.getItem('section');

		if (section && program) {
			navigate(`/${section}/program/${program}`);
		}
	}, [search, navigate]);

	return <></>;
};

export default ProgramPayment;
